// extracted by mini-css-extract-plugin
module.exports = {"guide":"OfferGuide-module--guide--3SS4P","guide_container":"OfferGuide-module--guide_container--3dOjN","guide_description":"OfferGuide-module--guide_description--3I4IR"};